import { BackgroundContainer } from "./styles";

const Component = () => {
  return <BackgroundContainer></BackgroundContainer>;
};

export default Component;
